export const DEFAULT_CONTENT_TEXT = 'Мы гарантируем безопасность и сохранность ваших данных';
